import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Download, Check } from "lucide-react";
import api from "@/lib/api";

// Compact gated lead-magnet form. Captures a lead of type 'lead_magnet'.
export const GatedDownload = ({ title = "Download the report", description, resource = "report", tone = "dark" }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const light = tone === "light";

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Please enter your work email."); return; }
    setLoading(true);
    try {
      await api.createLead({ type: "lead_magnet", email, consent: true, meta: { resource } });
      setDone(true);
      toast.success("Check your inbox", { description: "Your download link is on its way." });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="gated-download"
      className={`rounded-[var(--radius-lg)] border p-6 sm:p-8 ${light ? "border-[#E6E0D4] bg-white" : "border-[color:var(--bp-gold)]/35 bg-[color:var(--bp-surface)] grain-card"}`}
    >
      <p className="eyebrow text-[color:var(--bp-gold)]">Gated resource</p>
      <h3 className={`mt-3 font-display text-xl font-semibold ${light ? "text-[color:var(--bp-text-on-light)]" : "text-[color:var(--bp-cream)]"}`}>{title}</h3>
      {description && <p className={`mt-2 text-[14px] ${light ? "text-[color:var(--bp-text-body-on-light)]" : "text-[color:var(--bp-text-muted)]"}`}>{description}</p>}
      {done ? (
        <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-[color:var(--bp-success)]/40 px-4 py-2 text-[13px] text-[color:var(--bp-success)]">
          <Check className="h-4 w-4" /> Sent. Thank you.
        </p>
      ) : (
        <form onSubmit={submit} className="mt-5 flex flex-col gap-3 sm:flex-row">
          <input
            type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your work email"
            data-testid="gated-download-email"
            className={`h-12 w-full rounded-[var(--radius-sm)] border px-4 text-sm focus:outline-none ${light ? "border-[#E2DCCF] bg-[#FAF8F4] text-[color:var(--bp-text-on-light)] focus:border-[color:var(--bp-teal)]" : "border-[color:var(--bp-border)] bg-[color:var(--bp-bg-2)] text-[color:var(--bp-cream)] focus:border-[color:var(--bp-teal)]"}`}
          />
          <button type="submit" disabled={loading} data-testid="gated-download-submit" className="inline-flex h-12 shrink-0 items-center justify-center gap-2 rounded-[var(--radius-sm)] bg-[color:var(--bp-gold)] px-6 text-sm font-semibold text-[color:var(--bp-bg)] transition-shadow hover:shadow-[var(--shadow-lift)] disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Download
          </button>
        </form>
      )}
    </div>
  );
};
